import React from "react"
import { twMerge } from "tailwind-merge"
import Button from "aldoo-ra/Button"

const tones = {
  outline: "border border-text text-text hover:bg-text hover:text-white",
  primary: "bg-primary border border-primary text-white",
  dark: "bg-dark border border-dark text-white",
  success: "bg-success border border-success text-white",
  info: "bg-info border border-info text-white",
  warning: "bg-warning_bg border border-warning_bg text-warning",
  error: "bg-error border border-error text-white",
  neutral: "bg-neutral border border-neutral text-text",
  ghost: "border border-bordered text-text_secondary",
}
// what a clickable chip does under the pointer, per tone
const hovers = {
  ghost: "hover:border-text hover:text-text hover:bg-neutral",
  primary: "hover:bg-primary_dk hover:border-primary_dk",
}

// Rounded label / link chip
export default function Chip({ label, children, tone = "outline", to, onClick, size = "md", className = "", icon, ...rest }) {
  const cls = twMerge(
    "inline-flex items-center gap-1 rounded-full font-semibold whitespace-nowrap transition-colors",
    size === "sm" ? "h-6 px-2.5 text-xs" : "h-7 px-4 text-sm",
    tones[tone] || tones.outline,
    (to || onClick) && "cursor-pointer",
    (to || onClick) && hovers[tone],
    className
  )
  const content = (
    <>
      {icon}
      {label ?? children}
    </>
  )
  if (to) {
    return (
      <Button variant="none" href={to} className={cls} onClick={onClick} {...rest}>
        {content}
      </Button>
    )
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls} {...rest}>
        {content}
      </button>
    )
  }
  return <span className={cls} {...rest}>{content}</span>
}
